import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import AddEditUserForm from "@/components/network/AddEditUserForm";

export const Route = createFileRoute("/dashboard/network/users/new")({
    component: RouteComponent,
});

function RouteComponent() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    return (
        <AddEditUserForm
            onClose={(shouldRefetch) => {
                if (shouldRefetch) {
                    queryClient.invalidateQueries({ queryKey: ["users/"] });
                }
                navigate({
                    to: "/dashboard/network/users",
                    search: (prev) => prev,
                });
            }}
        />
    );
}
